// ----------------------------------------------------------------------

import BookACall from "../app/book-a-call/page";

export const paths = {
  home: "/",
  services: {
    root: `/services`,
    detail: (slug: string) => `/services/${slug}`,
    aiSaasProductDevelopment: `/services/ai-saas-product-development`,
    aiSaasMvpDevelopment: `/services/ai-saas-mvp-development`,
    generativeAiDevelopment: `/services/generative-ai-development`,
    aiChatbotDevelopment: `/services/ai-chatbot-development`,
    saasProductEngineering: `/services/saas-product-engineering-scaling`,
    aiIntegrationAutomation: `/services/ai-integration-automation`,
    ragPipelineDevelopment: `/services/rag-pipeline-development`,
    aiAgentDevelopment: `/services/ai-agent-development`,
    llmIntegrationDevelopment: `/services/llm-integration-development`,
    hireDedicatedReactjsDevelopers: `/services/hire-dedicated-reactjs-developers`,
    hireDedicatedNodejsDevelopers: `/services/hire-dedicated-nodejs-developers`,
    nodejsDevelopmentCompanyUSA: `/services/nodejs-development-company-usa`,
    reactjsDevelopmentCompanyUSA: `/services/reactjs-development-company-usa`,
    hireDedicatedDevlopmentTeamUSA: `/services/hire-dedicated-development-team-usa`,
    hireSassDevlopmentTeamUSA: `/services/saas-development-company-usa`,
    hireDevopsDevlopment: `/services/devops-engineering-services-usa`,
    devOpsEngineering: `/services/devops-engineering-services-usa`,
  },
  industries: {
    root: `/industries`,
    detail: (slug: string) => `/industries/${slug}`,
    fintechAiSolutions: `/industries/fintech-ai-solutions`,
    healthcareSoftwareDevelopment: `/industries/healthcare-software-development`,
    martechAiSolutions: `/industries/martech-ai-solutions`,
  },
  ourWork: {
    root: `/our-work`,
    avakeen: `/our-work/avakeen`,
    closeChat: `/our-work/close-chat`,
    beautyService: `/our-work/beauty-service`,
    helf: `/our-work/helf`,
    foodbite: `/our-work/foodbite`,
    rGuroo: `/our-work/r-guroo`,
  },
  blog: {
    root: `/blog`,
    post: (slug: string) => `/blog/${slug}`,
    tag: (tag: string) => `/blog/tag/${tag}`,
  },
  author: (slug: string) => `/author/${slug}`,
  caseStudies: {
    root: `/case-studies`,
    detail: (slug: string) => `/case-studies/${slug}`,
  },
  howWeWork: "/how-we-work",
  engagementModels: "/engagement-models",
  hireDeveloper: "/hire-developer",
  hireAiDevelopers: "/hire-ai-developers",
  hirePythonDevelopers: "/hire-python-developers",
  BookACall: "/book-a-call",
  aboutUs: "/about-us",
  contactUs: "/contact-us",
  thankYou: "/contact-us/thank-you",
  privacyPolicy: "/privacy-policy",
  bookACall: "/book-a-call",
  techeniac: "https://techeniac.com/",
  twitterTecheniac: "https://twitter.com/techeniac",
  dribbbleTecheniac: "https://dribbble.com/techeniacservicesllp",
  facebookTecheniac: "https://www.facebook.com/techeniacservicesllp/",
  instagramTecheniac:
    "https://www.instagram.com/life_at_techeniac?stkn=OHF5bnlrcnN3MnR5",
  linkedinTecheniac: "https://www.linkedin.com/company/techeniac-services-llp",
  clutchTecheniac:
    "https://clutch.co/profile/techeniac-web-app-development-company#summary",
  clutchHighlightsTecheniac:
    "https://clutch.co/profile/techeniac-web-app-development-company#highlights",
  goodfirmsTecheniac: "https://www.goodfirms.co/company/techeniac-services-llp",
  googleTecheniac: "https://g.co/kgs/uHocBh",
  trustpilotTecheniac: "https://www.trustpilot.com/review/techeniac.com",
  foursquareTecheniac:
    "https://foursquare.com/v/techeniac-services-llp/6525449ff1432851a2aa56a0",
  coolMembershipTemplate: "https://cool-membership-template.webflow.io/signup",
  meetingsHubspotAkash: "https://meetings.hubspot.com/akash-kapoor",
  meetingsHubspotShubham: "https://meetings.hubspot.com/shubham-makwana",
  meetingsHubspotGuddu: "https://meetings-na2.hubspot.com/guddu",
  calendlyGuddu: "https://calendly.com/guddu-techeniac/30min",
  contactFormSubmitURL:
    "https://wptecheniac.developmentservers.in/wp-json/contact-form-7/v1/contact-forms/30/feedback",
  codingyaarVideo:
    "https://codingyaar.com/wp-content/uploads/video-in-bootstrap-card.mp4",
  whatsAppURL: "https://api.whatsapp.com/send?phone=+918140085842&text=Hello",
  telegramURL: "https://t.me/vatsal68374",
};
